
export const orangeConfig={
    authorization_token:'Basic RDBPMldIclc2QjRyeW5hU2VOWXVHUTJaR29QSUcwQzU6Q1c3T2FIZ2xnWWpETlVxOA=='
}